const state = () => ({
  DataFrom3: {
    tes_id: "",

    stu_birth: "",
    stu_age: "",
    stu_nation: "099",
    stu_lineage: "099",
    stu_relagion: "",
    stu_blood: "",
    stu_sex: "",
    stu_brother: "",
    stu_sister: "",
    stu_order: "",
    stu_weight: "",
    stu_height: "",
    stu_health: "",
    stu_parent_status: "",
    stu_email: "",
    stu_spacial: "",
    stu_hand_write: "",
    stu_piercing_ear: "",
    stu_tattoo: "",
    stu_receipt_news_other: "",

    stu_father_birth: "",
    father_prename: "",
    stu_father_fname: "",
    stu_father_lname: "",
    stu_fat_occ: "",
    stu_fat_mon: 0,
    stu_father_state: "",
    stu_father_defective: "",

    stu_mother_birth: "",
    mother_prename: "",
    stu_mother_fname: "",
    stu_mother_lname: "",
    stu_mom_occ: "",
    stu_mom_mon1: 0,
    stu_mother_state: "",
    stu_mother_defective: "",

    student_loan_stat: "",
    student_loan_continus: "",

    select_year: "",
  },

  DataNation: [],
  DataLineage: [],
  Datareligion: [],
  DataBlood: [],
  DataParentStatus: [],
  DataOccupationNew: [],
  DataDefective: [],
  DataLivingstate: [],
  SetStep3: [],
  DataSignup_date: [],
  DataStep3: [],
});
/* ========== getters ========== */
const getters = {
  _getDataFrom3: (state) => {
    return state.DataFrom3;
  },
  _getDataNation: (state) => {
    return state.DataNation;
  },
  _getDataLineage: (state) => {
    return state.DataLineage;
  },
  _getDataReligion: (state) => {
    return state.Datareligion;
  },
  _getDataBlood: (state) => {
    return state.DataBlood;
  },
  _getDataParentStatus: (state) => {
    return state.DataParentStatus;
  },
  _getDataOccupationNew: (state) => {
    return state.DataOccupationNew;
  },
  _getDataDefective: (state) => {
    return state.DataDefective;
  },
  _getDataLivingstate: (state) => {
    return state.DataLivingstate;
  },
  _SetStep4: (state) => {
    return state.SetStep3;
  },
  _GetSignup_date: (state) => {
    return state.DataSignup_date;
  },
  _GetDataStep3: (state) => {
    return state.DataStep3;
  },
};
/* ========== actions ========== */
const actions = {
  async SetStepStatus({ state, rootState }) {
    // ======================== เบิกวันที่ปัจจุบันผ่าน APIs ========================
    try {
      const response = await window.Axios.post(
        `${window.api}exec/GetStepStatus3/`,
        state.DataFrom3
      );
      // console.log(response);
      state.DataStep3 = response.data;
      rootState.Main.DataStep3 = response.data;
    } catch (error) {
      console.error(error);
    }
  },
  async SetStep3({ state }) {
    // ======================== เบิกวันที่ปัจจุบันผ่าน APIs ========================
    try {
      let data = {
        tes_id: state.DataFrom3.tes_id,
      };
      const response = await window.Axios.post(
        `${window.api}post/GetStep3/`,
        data
      );
      state.SetStep3 = response.data;

      const statStep3 = state.SetStep3;
      const From3 = state.DataFrom3;

      if (state.SetStep3 != "") {
        From3.stu_birth = statStep3.stu_birth;
        From3.stu_age = statStep3.stu_age;
        From3.stu_nation =
          statStep3.stu_nation == ""
            ? (From3.stu_nation = statStep3.stu_nation.trim())
            : "099";
        From3.stu_lineage =
          statStep3.stu_lineage == ""
            ? (From3.stu_lineage = statStep3.stu_lineage.trim())
            : "099";
        From3.stu_relagion = statStep3.stu_relagion;
        statStep3.stu_blood
          ? (From3.stu_blood = statStep3.stu_blood.trim())
          : "";
        From3.stu_sex = statStep3.stu_sex;
        From3.stu_brother = statStep3.stu_brother;
        From3.stu_sister = statStep3.stu_sister;
        From3.stu_order = statStep3.stu_order;
        From3.stu_weight = statStep3.stu_weight;
        From3.stu_height = statStep3.stu_height;
        From3.stu_health = statStep3.stu_health;
        From3.stu_parent_status = statStep3.stu_parent_status;
        statStep3.stu_email
          ? (From3.stu_email = statStep3.stu_email.trim())
          : "";
        From3.stu_spacial = statStep3.stu_spacial;
        From3.stu_hand_write = statStep3.stu_hand_write;
        From3.stu_piercing_ear = statStep3.stu_piercing_ear;
        From3.stu_tattoo = statStep3.stu_tattoo;
        From3.stu_receipt_news_other = statStep3.stu_receipt_news_other;

        From3.stu_father_birth = statStep3.stu_father_birth;
        statStep3.father_prename
          ? (From3.father_prename = statStep3.father_prename.trim())
          : "";
        From3.stu_father_fname = statStep3.stu_father_fname;
        From3.stu_father_lname = statStep3.stu_father_lname;
        From3.stu_fat_occ = statStep3.stu_fat_occ;
        statStep3.stu_fat_mon == ".00" || statStep3.stu_fat_mon == null
          ? (From3.stu_fat_mon = "0")
          : (From3.stu_fat_mon = statStep3.stu_fat_mon.split(".")[0]);
        statStep3.stu_father_state
          ? (From3.stu_father_state = statStep3.stu_father_state.trim())
          : "";
        statStep3.stu_father_defective
          ? (From3.stu_father_defective = statStep3.stu_father_defective.trim())
          : "";

        From3.stu_mother_birth = statStep3.stu_mother_birth;
        statStep3.mother_prename
          ? (From3.mother_prename = statStep3.mother_prename.trim())
          : "";
        From3.stu_mother_fname = statStep3.stu_mother_fname;
        From3.stu_mother_lname = statStep3.stu_mother_lname;
        From3.stu_mom_occ = statStep3.stu_mom_occ;
        statStep3.stu_mom_mon1 == ".00" || statStep3.stu_mom_mon1 == null
          ? (From3.stu_mom_mon1 = "0")
          : (From3.stu_mom_mon1 = statStep3.stu_mom_mon1.split(".")[0]);
        statStep3.stu_mother_state
          ? (From3.stu_mother_state = statStep3.stu_mother_state.trim())
          : "";
        statStep3.stu_mother_defective
          ? (From3.stu_mother_defective = statStep3.stu_mother_defective.trim())
          : "";

        From3.student_loan_stat = statStep3.student_loan_stat;
        From3.student_loan_continus = statStep3.student_loan_continus;
      }
    } catch (error) {
      console.error(error);
    }
  },
  async GET_DataNation({ commit }) {
    try {
      const response = await window.Axios.get(`${window.api}get/GetNation/`);
      await commit("GET_DataNation", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async GET_DataLineage({ commit }) {
    try {
      const response = await window.Axios.get(`${window.api}get/GetLineage/`);
      await commit("GET_DataLineage", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async GET_DataReligion({ commit }) {
    try {
      const response = await window.Axios.get(`${window.api}get/GetReligion/`);
      await commit("GET_DataReligion", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async GET_DataBlood({ commit }) {
    try {
      const response = await window.Axios.get(`${window.api}get/GetBlood/`);
      await commit("GET_DataBlood", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async GET_DataParentStatus({ commit }) {
    try {
      const response = await window.Axios.get(
        `${window.api}get/GetParentStatus/`
      );
      await commit("GET_DataParentStatus", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async GET_DataOccupationNew({ commit }) {
    try {
      const response = await window.Axios.get(
        `${window.api}get/GetOccupationNew/`
      );
      await commit("GET_DataOccupationNew", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async GET_DataDefective({ commit }) {
    try {
      const response = await window.Axios.get(`${window.api}get/GetDefective/`);
      await commit("GET_DataDefective", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async GET_DataLivingstate({ commit }) {
    try {
      const response = await window.Axios.get(
        `${window.api}get/GetLivingstate/`
      );
      await commit("GET_DataLivingstate", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async GET_Signup_date({ commit }) {
    try {
      const response = await window.Axios.get(
        `${window.api}get/GetSignup_date/`
      );
      await commit("GET_Signup_date", response.data);
    } catch (error) {
      console.error(error);
    }
  },
};

/* ========== mutations ========== */
const mutations = {
  GET_DataNation(state, payload) {
    state.DataNation = payload;
  },
  GET_DataLineage(state, payload) {
    state.DataLineage = payload;
  },
  GET_DataReligion(state, payload) {
    state.Datareligion = payload;
  },
  GET_DataBlood(state, payload) {
    state.DataBlood = payload;
  },
  GET_DataParentStatus(state, payload) {
    state.DataParentStatus = payload;
  },
  GET_DataOccupationNew(state, payload) {
    state.DataOccupationNew = payload;
  },
  GET_DataDefective(state, payload) {
    state.DataDefective = payload;
  },
  GET_DataLivingstate(state, payload) {
    state.DataLivingstate = payload;
  },
  GET_Signup_date(state, payload) {
    state.DataSignup_date = payload;
  },
};

/* ========== Export ========== */
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
